module.exports = __webpack_public_path__ + "static/media/logo-black.97b0696b.svg";